/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import CustomerSupport from "./features/customersupport";

const Support = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <CustomerSupport />
        </section>
      </Layout>
    </>
  );
};
export default Support;
